import { BarChart3, Briefcase, Calendar, Layers, Mail, MessageSquare, Settings, ShoppingCart, Users } from "lucide-react";

export const notifications = [
    { id: 1, title: 'New user registered', desc: 'John Doe joined the platform', time: '2 min ago', read: false, type: 'user' },
    { id: 2, title: 'Order #1234 placed', desc: 'New order worth $2,400', time: '15 min ago', read: false, type: 'order' },
    { id: 3, title: 'Server alert', desc: 'CPU usage at 85% — check now', time: '1 hr ago', read: true, type: 'alert' },
    { id: 4, title: 'Weekly report ready', desc: 'Your analytics report is ready', time: '2 hr ago', read: true, type: 'report' },
];

export const appsList = [
    { label: 'Analytics', path: '/analytics', icon: BarChart3, color: "warning" },
    { label: 'Ecommerce', path: '/', icon: ShoppingCart, color: "success" },
    { label: 'Chat', path: '/messages', icon: MessageSquare, color: "info" },
    { label: 'Calendar', path: '/calendar', icon: Calendar, color: "primary" },
    { label: 'Email', path: '/email', icon: Mail, color: "danger" },
    { label: 'Products', path: '/products', icon: Layers, color: "info" },
    { label: 'HRMS', path: '/hrms', icon: Users, color: "secondary" },
    { label: 'Jobs', path: '/jobs', icon: Briefcase, color: "success" },
    { label: 'Settings', path: '/settings', icon: Settings, color: "secondary" },
];

export const languagesList = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'hi', name: 'Hindi', flag: '🇮🇳' },
    { code: 'ar', name: 'Arabic', flag: '🇸🇦' },
    { code: 'it', name: 'Italian', flag: '🇮🇹' },
];